import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { updateCustomBullets } from "./swiperPagination";

// Swiper.use([Navigation]);

class ArticlesSlider {
  swiperElement: HTMLElement;
  swiperInstance: Swiper | null;

  constructor(swiperElement: HTMLElement) {
    this.swiperElement = swiperElement;
    this.swiperInstance = null;
    this.initSwiper();
  }

  initSwiper() { 
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 3,
      spaceBetween: 20,

      pagination: {
        el: this.swiperElement.querySelector(
          ".swiper-pagination"
        ) as HTMLElement,
        clickable: true,
        dynamicBullets: false,
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },

      on: {
        init: (swiperInstance) => updateCustomBullets(swiperInstance),
        slideChange: (swiperInstance) => updateCustomBullets(swiperInstance),
        paginationUpdate: (swiperInstance) => updateCustomBullets(swiperInstance),
      }
    });
  }
}

// document.querySelectorAll<HTMLElement>(".articles-col-swiper").forEach((el) => {
//   new ArticlesSlider(el);
// });

document
  .querySelectorAll<HTMLElement>(".articles-col-swiper")
  .forEach((el) => {
     new ArticlesSlider(el);
});